import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useTranslation } from 'next-i18next';
import { Modal } from '@components/common/Modal/Modal';
import { useHandleSubscriptionModalClose } from '@components/templates/employer/subscription/utils';
import { PaymentOnlyHubModal } from '@components/templates/employer/subscription/PaymentOnlyHubModal';


/**
 * @description Renders the payment packages modal (subscriptions & bundles), with payment options,
 * pricing and if it's the case the 'not enough credits' and payment status possible steps. Unlike
 * the SubscriptionsModal and UpgradeSubscriptionModal, this modal handles only the payment part without
 * any package selection.
 *
 * The modal can be opened anywhere in the app using the **showPaymentPackagesModal** function.
 */
export const PaymentPackagesModal = NiceModal.create(() => {
  // Use a hook to manage the modal state
  const modal = useModal();

  // Close modal
  const closeModal = () => {
    void modal.hide();
  };

  // Translation
  const { t } = useTranslation('common');

  // Cleanup Redux states and re-fetch after closing the modal depending on the flow step
  const { handleSubscriptionModalClose } = useHandleSubscriptionModalClose();


  // Render component
  // *****************************************
  return (
    <Modal
      backdropClickDisabled
      isOpen={modal.visible}
      onClose={closeModal}
      afterLeave={handleSubscriptionModalClose}
      size="lg"
      header={t('global.action.order')}
      body={<PaymentOnlyHubModal closeModal={closeModal} />}
    />
  );
});


/**
 * @description Opens the payment packages modal anywhere in the app. Modal comes with payment options,
 * pricing and if it's the case the 'not enough credits' and payment status possible steps. No package
 * selection is available in this modal.
 *
 * @example
 * // import
 * import { showPaymentPackagesModal } from '@components/features/modals/employer/PaymentPackagesModal';
 * // usage
 * <Button onClick={showPaymentPackagesModal}>Show payment packages modal</Button>
 */
export const showPaymentPackagesModal = () => {
  void NiceModal.show(PaymentPackagesModal);
};
